"use client"

import { Pagination, PaginationItem } from "@mui/material"
import Link from "next/link"

interface Props {
    tagSlug: string
    count: number
    page: number
}

export const LibraryItemsPagination = ({ tagSlug, count, page }: Props) => {
    return (
        <Pagination
            count={count}
            page={Number(page)}
            renderItem={(item) => {
                return !item.disabled &&
                    item.type !== "end-ellipsis" &&
                    item.type !== "start-ellipsis" ? (
                    <Link href={`/summaries/${tagSlug}/${item.page}`}>
                        <PaginationItem {...item} />
                    </Link>
                ) : (
                    <PaginationItem {...item} />
                )
            }}
        />
    )
}
